import lottie from 'lottie-web';
import animationData from '../../assets/lottiefiles/loader.lottie.json';

export class LinkLoaderComponent {
    element = null;

    constructor(element) {
        this.element = element;
        this.initEventListener();
    }

    initEventListener() {
        this.element.addEventListener('click', () => {
            let loaderElementLoader = this.element.getElementsByClassName('aib--link-loader-loader')[0];

            if(loaderElementLoader) {
                loaderElementLoader.style.height = loaderElementLoader.clientHeight + 'px';
                loaderElementLoader.style.width = loaderElementLoader.clientWidth + 'px';

                loaderElementLoader.querySelector('i').classList.add('hidden');

                if(loaderElementLoader.querySelector('svg')) {
                    loaderElementLoader.querySelector('svg').remove();
                }

                lottie.loadAnimation({
                    container: loaderElementLoader,
                    loop: true,
                    autoplay: true,
                    animationData,
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                        className: "lottie-svg-class",
                    }
                });
            }
        });
    }

    end() {
        let loaderElementLoader = this.element.getElementsByClassName('aib--link-loader-loader')[0];
        loaderElementLoader.querySelector('i').classList.remove('hidden');
        loaderElementLoader.querySelector('svg').remove();
    }

    static init() {
        let elements = document.querySelectorAll('a.aib--link-loader:not([disabled]), button.aib--link-loader:not([disabled])');

        elements.forEach((element) => {
            new LinkLoaderComponent(element);
        });
    }
}

window.LinkLoaderComponent = LinkLoaderComponent;